import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=def2b734&scoped=true"
import script from "./calendar.vue?vue&type=script&lang=js"
export * from "./calendar.vue?vue&type=script&lang=js"
import style0 from "./calendar.vue?vue&type=style&index=0&id=def2b734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def2b734",
  null
  
)

export default component.exports